import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "client_process_invoice_creation_div" }
const _hoisted_2 = { class: "category_title" }
const _hoisted_3 = {
  key: 0,
  class: "action_title"
}
const _hoisted_4 = {
  key: 1,
  class: "action_title"
}
const _hoisted_5 = {
  key: 2,
  class: "action_title"
}
const _hoisted_6 = {
  key: 3,
  class: "process_debit_infos_div"
}
const _hoisted_7 = { class: "process_debit_infos" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "Période de facturation ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "process_debit_infos" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("strong", null, "Volume d'affaire", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "process_debit_infos" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("strong", null, "Montant du pour les étiquettes", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "process_debit_infos" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("strong", null, "Montant frais supplémentaire", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = { class: "process_debit_infos" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("strong", null, "Montant total facture", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_25 = {
  key: 0,
  class: "discount"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "discount_title" }, "Remise", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "define_amount_to_debit",
  value: "define"
}, null, -1)
const _hoisted_28 = { key: 1 }
const _hoisted_29 = {
  key: 4,
  class: "process_debit_actions"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("input", {
  class: "submit_button",
  type: "submit",
  name: "",
  value: "Terminer le processus"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("a", {
      href: "#",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.go_back_to_sellers_vue()))
    }, "Revenir à l'accueil"),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.seller.compagny_name), 1),
      (_ctx.state === 1)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_3, "Définir le montant de la facturation"))
        : (_ctx.state === 1.1)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_4, "Confirmer le montant de la facturation"))
          : _createCommentVNode("", true),
      (_ctx.state === 2)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_5, "Télécharger et envoyer les factures"))
        : _createCommentVNode("", true),
      (_ctx.state === 1 || _ctx.state === 1.1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, [
              _hoisted_8,
              _hoisted_9,
              _createTextVNode(" " + _toDisplayString(_ctx.seller.previous_debit_date) + " - " + _toDisplayString(_ctx.seller.next_debit_date), 1)
            ]),
            _createElementVNode("p", _hoisted_10, [
              _hoisted_11,
              _hoisted_12,
              (Array.isArray(_ctx.seller.total_transaction_amount))
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.seller.total_transaction_amount, (amount, index) => {
                    return (_openBlock(), _createElementBlock("span", { key: index }, [
                      _createTextVNode(_toDisplayString(amount) + " € TTC", 1),
                      _hoisted_13
                    ]))
                  }), 128))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_ctx.seller.total_transaction_amount) + " € TTC ", 1)
                  ], 64))
            ]),
            _createElementVNode("p", _hoisted_14, [
              _hoisted_15,
              _hoisted_16,
              _createTextVNode(" " + _toDisplayString(_ctx.seller.total_shipping_costs_ht) + " € HT ", 1)
            ]),
            _createElementVNode("p", _hoisted_17, [
              _hoisted_18,
              _hoisted_19,
              _createTextVNode(" " + _toDisplayString(_ctx.seller.total_other_fees_ht) + " € HT ", 1)
            ]),
            _createElementVNode("p", _hoisted_20, [
              _hoisted_21,
              _hoisted_22,
              _createTextVNode(" " + _toDisplayString(_ctx.seller.total_amount_due_ht) + " € HT ", 1),
              _hoisted_23,
              (_ctx.seller.total_amount_due_ttc !== null)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.seller.total_amount_due_ttc) + " € TTC ", 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _hoisted_24,
            (_ctx.state === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _hoisted_26,
                  _withDirectives(_createElementVNode("input", {
                    class: "input",
                    type: "text",
                    name: "discount_desc",
                    placeholder: "Description",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.discountDesc) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.discountDesc]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    class: "input",
                    type: "number",
                    step: "0.01",
                    name: "discount_amount_ht",
                    placeholder: "Montant (HT)",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.discountAmountHt) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.discountAmountHt]
                  ]),
                  _hoisted_27,
                  _createElementVNode("input", {
                    class: "submit_button",
                    type: "submit",
                    name: "",
                    value: "Soumettre",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.go_to_billing_process_invoice_creation_state_1_1()))
                  })
                ]))
              : (_ctx.state === 1.1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createElementVNode("input", {
                      type: "button",
                      value: "Précédent",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.go_to_billing_process_invoice_creation_state_1()))
                    }),
                    _createElementVNode("input", {
                      type: "button",
                      value: "Editer les factures",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.go_to_billing_process_invoice_creation_state_2()))
                    })
                  ]))
                : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.state === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createElementVNode("input", {
              class: "invoice_and_docs_action_button",
              type: "submit",
              name: "",
              value: "Télécharger facture",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.get_invoice_infos_for_download()))
            }),
            _createElementVNode("input", {
              class: "invoice_and_docs_action_button",
              type: "submit",
              name: "",
              value: "Envoyer par mail",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.post_send_invoice_by_email()))
            }),
            _withDirectives(_createElementVNode("input", {
              class: "input debit_seller_postpone_amount_input",
              type: "text",
              name: "postpone_amount",
              placeholder: "Montant à rajouter en € (vide sinon)",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.postpone_amount) = $event))
            }, null, 512), [
              [_vModelText, _ctx.postpone_amount]
            ]),
            _createElementVNode("input", {
              class: "invoice_and_docs_action_button",
              type: "submit",
              name: "",
              value: "Prélever",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.post_debit_seller()))
            }),
            _hoisted_30
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}